import React from 'react';
import styled, { css } from 'styled-components';
import Button, { buttonStyles, LinkButton } from 'components/Button/Button';

import { minBp } from '../../lib/theme';

export const Container = styled.section`
  ${({ theme, hideOnDesktop, isScrolling }) => `
    display: flex;
    align-items: center;
    height: ${theme.heights.tray.mobile}px;
    z-index: 102;
    width: 100%;
    position: fixed;
    bottom: 0;
    transition: height 0.3s ease;
    height: ${isScrolling ? '34px' : '70px'};
    

    @media ${minBp('tablet')} {
      transition: unset;
      height: ${theme.heights.tray.tablet}px;
    }

    @media ${minBp('tabletLarge')} {
      height: ${theme.heights.tray.desktop}px;
      display: ${hideOnDesktop ? 'none' : 'flex'};
    }
  `}
`;

export const BoxShadow = styled.div`
  height: 20px;
  top: -20px;
  position: absolute;
  width: 100%;
  background: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 100%);
  pointer-events: none;

  @media ${minBp('desktop')} {
    height: 30px;
    top: -30px;
  }
`;

export const PrevNextStyles = css`
  ${({ nextBtn, isLastStep, financeHidden }) => `
    background: ${nextBtn ? '#cd192d' : '#a7a9ac'};
    color: ${nextBtn ? '#fff' : '#000'};
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    cursor: pointer;
    margin: 0;
    flex-basis: 0;
    line-height: 1.15;
    padding: 2px 22px 0;
    text-align: left;
    min-width: ${isLastStep ? '50%' : '140px'};
    // min-width: ${isLastStep || financeHidden ? '120px' : '60px'};
    // max-width: ${isLastStep || financeHidden ? '120px' : '60px'};

    @media ${minBp('additional.mobile')} {
      min-width: ${isLastStep ? '50%' : '160px'};
    }

    @media ${minBp('tablet')} {
      max-width: none;
    }

    &:hover,
    &:focus {
      background: ${nextBtn ? '#8F111F' : '#8E9093'}
    }

    &:disabled {
      background: #a7a9ac;
      cursor: not-allowed;
      opacity: 1;
    }

    ${!nextBtn && 'display: none'}

    @media ${minBp('desktop')} {
      padding: 2px 30px 0;
      text-align: center;
      ${!nextBtn && 'display: flex'};
    }
  `}
`;

export const PrevNextButton = styled(Button)`
  ${buttonStyles}
  ${PrevNextStyles}
`;

export const PrevNextLink = styled(LinkButton)`
  ${buttonStyles}
  ${PrevNextStyles}
  display: flex;
  background: #cd192d;
  color: #fff;

  &:hover,
  &:focus {
    background: #8f111f;
  }

  svg {
    margin-left: 5px;
    width: 15px;
    min-width: 15px;

    @media ${minBp('tablet')} {
      margin-left: 0;
      width: 16px;
    }
  }
`;

export const PrevNextLinkA = styled.a`
  ${buttonStyles}
  ${PrevNextStyles}
  display: flex;
  background: #cd192d;
  color: #fff;

  @media ${minBp('additional.mobile')} {
    padding: 2px 30px 0;
  }

  &:hover,
  &:focus {
    background: #8f111f;
  }

  svg {
    margin-left: 5px;
    width: 15px;
    min-width: 15px;

    @media ${minBp('tablet')} {
      margin-left: 0;
      width: 16px;
    }
  }
`;

export const PrevNextText = styled.span`
  ${({ nextBtn, isMac, isLastStep, financeHidden }) => `
    display: flex;
    align-items: center;

    @media ${minBp('desktop')} {
      margin: 0 8px;
    }

    span {
      display: inline-block;
      // display: ${isLastStep || financeHidden ? 'inline-block' : 'none'};
      margin-right: ${isLastStep || financeHidden ? '8px' : 0};

      @media ${minBp('tablet')} {
        display: inline;
        margin: 0;
      } 
    }

    svg {
      position: relative;
      top: auto;
      bottom: ${isMac ? '1px' : '2px'};
      width: 10px;
      height: 10px;
      vertical-align: middle;

      @media ${minBp('tablet')} {
        margin-right: ${nextBtn ? '0' : '5px'};
        margin-left: ${nextBtn ? '5px' : '0px'};
      }

      @media ${minBp('desktop')} { 
        top: auto;
        bottom: ${isMac ? '1px' : '2px'};
      }
    }
`}
`;

export const ConfigOptionsContainer = styled.div`
  ${({ trayModalOpen }) => `
    display: ${trayModalOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: fixed;
    top: 0;
    background: #fff;
    width: 100%;
    z-index: 11;
    height: 100%;

    @media ${minBp('desktop')} {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      top: auto;
      flex-grow: 2;
      height: 100%;
      width: auto;
      z-index: 2;
    }
  `}
`;

export const ConfigOptionsCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 10px;
  position: absolute;
  top: 12px;
  right: 18px;
`;

export const FinanceOptionsContainer = styled.div`
  ${({ theme, financeHidden }) => `
    display: flex;
    flex-grow: 1;
    height: 100%;
    align-items: center;
    background-color: #000;
    color: #fff;

    @media ${minBp('tablet')} {
      flex-grow: 0.5;
      min-width: ${financeHidden ? '225px' : '450px'};
    }
  `}
`;

export const ConfigOptionsStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #fff;
  font-size: 14px;
  text-decoration: none;
  color: #585a5f;
  height: 50px;
  margin: 0 30px;
  cursor: pointer;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #e0e0e0;
  border-left: 1px solid transparent;
  border-right: none;
  position: relative;
  padding: 0;

  @media ${minBp('desktop')} {
    border-right: 1px solid #e0e0e0;
    flex: 1;
    margin: 0;
  }

  svg {
    position: absolute;
    right: 30px;

    @media ${minBp('desktop')} {
      position: static;
    }

    path {
      fill: #000;
    }
  }

  @media ${minBp('desktop')} {
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
    justify-content: center;

    svg {
      display: none;
    }
  }
`;

export const ConfigOptions = styled.button`
  ${ConfigOptionsStyles}

  ${({ disabled }) =>
    disabled
      ? `
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  `
      : ``}
`;

export const ConfigOptionsLink = styled(LinkButton)`
  ${ConfigOptionsStyles}

  text-transform: none;
  justify-content: flex-start;

  :focus-visible {
    outline: auto 1px Highlight;
    outline: auto 1px -webkit-focus-ring-color;
    outline-offset: 0;
  }

  @media ${minBp('desktop')} {
    padding: 0;
  }
`;

export const ConfigOptionsLinkA = styled.a`
  ${ConfigOptionsStyles}

  text-transform: none;
  justify-content: flex-start;

  :focus-visible {
    outline: auto 1px Highlight;
    outline: auto 1px -webkit-focus-ring-color;
    outline-offset: 0;
  }

  @media ${minBp('desktop')} {
    padding: 0px;
  }
`;

export const ConfigOptionsHeader = styled.div`
  background-color: #a7a9ac;
  padding: 21px 30px 17px;
  margin-bottom: 33px;

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const ConfigOptionsTitle = styled.span`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 17px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 22px;
  color: #000;
`;

export const ConfigOptionsLabelWrapper = styled.span`
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  display: block;
  margin-left: 20px;
  font-size: 16px;

  @media ${minBp('desktop')} {
    margin-left: 0;
  }
`;

export const ConfigOptionsModalButton = styled.button`
  background: #a7a9ac;
  height: 100%;
  flex-grow: 1;
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-decoration: none;
  color: #585a5f;
  border: none;
  max-width: 40px;
  margin: 0;

  @media ${minBp('additional.mobile')} {
    max-width: 60px;
  }

  @media ${minBp('tablet')} {
    flex-grow: 0.4;
    max-width: 150px;
  }

  @media ${minBp('desktop')} {
    display: none;
    flex-grow: 1;
  }
`;

export const ConfigOptionsBackButton = styled.button`
  ${buttonStyles}
  ${PrevNextStyles}

  max-width: none;
  display: block;
  background: #cd192d;
  height: 60px;
  color: #fff;
  width: 100%;

  &:hover,
  &:focus {
    background: #8f111f;
  }

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const ConfigOptionsBackButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  ${ConfigOptionsBackButton} {
    text-align: center;
  }
`;

export const InfoButton = styled.button`
  margin-right: 12px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;

  svg {
    pointer-events: none;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }

  @media ${minBp('tablet')} {
    margin-right: 14px;
  }

  @media ${minBp('tabletLarge')} {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const FinanceOptionWrap = styled.div`
  ${({ monthlyBreakdown, financeHidden }) => `
    // display: ${monthlyBreakdown ? 'none' : 'flex'};
    // align-items: center;
    font-size: 14px;
    height: 100%;
    text-decoration: none;
    color: #fff;
    flex: 1;
    // padding: 0 8px 0 16px;
    appearance: none;
    text-align: left;
    border: 0;
    background: transparent;

    &:not(:last-child) {
      border-right: 1px solid #4c4c4c;
    }

    @media ${minBp('tablet')} {
      // display: flex;
      // flex-direction: row;
      // justify-content: flex-start;
      // align-items: center;
      // padding: 0 16px 0 32px;
    }

    @media ${minBp('tabletLarge')} {
      // padding-left: 16px;
      // max-width: ${financeHidden ? '100%' : '50%'};
      max-width: 100%;
      // justify-content: center;
    }
  `}
`;

export const PriceOptionsLabelWrapper = styled(ConfigOptionsLabelWrapper)`
  font-size: 12px;
  margin: 0;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }
`;

export const FinanceOptionsLabelWrapper = styled(ConfigOptionsLabelWrapper)`
  font-size: 12px;
  margin: 0;

  svg {
    width: 8px;
    height: 7px;
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    right: 0;
    top: 3px;
    margin: 0;

    path {
      fill: white;
    }
  }

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }
`;

export const Icon = styled.img`
  height: 32px;
  width: 32px;
`;

export const Price = styled.span`
  color: #fff;
  font-size: 15px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  margin-top: 2px;
  line-height: 1;

  @media ${minBp('tablet')} {
    font-size: 17px;
    display: flex;
    align-items: center;
    font-family: ${({ theme }) => theme.fonts.dinRegular};
  }

  @media ${minBp('desktop')} {
    font-size: 22px;
  }
`;

export const PriceWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    margin: 0 auto;
    padding: 0 10px;
  `}
`;

export const FinanceWrapper = styled.div`
  ${({ theme }) => `  
    display: flex;
    align-items: center;
    position: relative;

    & > svg {
      width: 18px;
      height: 23px;
      margin-right: 8px;

      path {
        fill: white;
      }
    }

    @media ${minBp('tablet')} {
      & > svg {
        margin-right: 15px;
      }
    }
  `}
`;

export const GarageCount = styled.div`
  left: 25px;
  top: 4px;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: red;
  color: white;
  position: absolute;
  border-radius: 50%;
  padding: 0;

  @media ${minBp('desktop')} {
    top: 5px;
    left: 50%;
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: inherit;
  }
`;

export const FinanceButton = styled.button`
  font-family: inherit;
  font-size: inherit;
  color: white;
  padding: 0;
  background: transparent;
  border: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

export const FinanceLabel = styled.span`
  text-decoration: underline;
  font-size: 12px;
  color: white;
  margin-top: 2px;
`;
